import gatsbyConfig from '../gatsby-config'

export const { githubRepoUrl, siteUrl, locale } = gatsbyConfig.siteMetadata
